import { API_ROUTE_ADMIN_FEATURE_ACTIVE_CUSTOMERS } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export type CustomerSelectList = {
  id: number
  name: string
}

export const getCustomersWithActiveFeature = async (name: string) =>
  get<CustomerSelectList[]>(
    API_ROUTE_ADMIN_FEATURE_ACTIVE_CUSTOMERS.replace(':featureName', name),
    IS_NEW_BACKEND_API
  )
